module.exports = __webpack_public_path__ + "static/media/06_Primadonna_(Lilliana)_eq 03-25.1585b045.mp3";